import React, { Component } from 'react';
import { translate } from 'react-i18next';
import { esimApi } from './esimApi';

class ESIMMyPlans extends Component {
    state = {
        activeFilter: 'all',
        limit: {
            used: 120,
            total: 500,
            currency: 'AZN'
        },
        filters: [
            { key: 'all', label: 'Hamısı' },
            { key: 'pending', label: 'Gözləmədə' },
            { key: 'active', label: 'Aktiv' },
            { key: 'expired', label: 'Müddəti Bitmiş' }
        ],
        plans: [],
        helpInfo: {
            title: 'Toplu köçürmələr necə edilir?',
            description: 'Ölkədaxili köçürmə zamanı vəsaiti alan tərəfin hesabı respublika daxilində istənilən bankda mövcud ola bilər. Vəsaiti alan şəxsın bank seçilir və alan şəxsın'
        },
        isLoading: false
    }

    componentDidMount = () => {
        this.loadMyEsims();
    }

    getPlanStatusAndAction = (item) => {
        const displayState = (item.displayState || '').toUpperCase();
        const canTopUp = Boolean(item.canTopUp);
        const depleted = Boolean(item.depleted);

        if (displayState === 'ACTIVE') {
            return {
                status: 'pending',
                statusLabel: 'Gözləmədə',
                primaryAction: 'Setup'
            };
        }

        if (displayState === 'IN_USE') {
            return {
                status: 'active',
                statusLabel: 'Aktiv',
                primaryAction: canTopUp || depleted ? 'Top Up' : null
            };
        }

        if (displayState === 'EXPIRED') {
            return {
                status: 'expired',
                statusLabel: 'Müddəti bitmiş',
                primaryAction: 'Reinstall'
            };
        }

        if (displayState === 'CANCELLED') {
            return {
                status: 'expired',
                statusLabel: 'Ləğv edilmiş',
                primaryAction: 'Reinstall'
            };
        }

        const fallbackStatus = (item.status || '').toLowerCase();
        return {
            status: fallbackStatus || 'active',
            statusLabel: item.displayState || 'Aktiv',
            primaryAction: fallbackStatus === 'pending' ? 'Setup' : fallbackStatus === 'expired' ? 'Reinstall' : 'Top Up'
        };
    }

    loadMyEsims = async () => {
        this.setState({ isLoading: true });

        try {
            const [esimsResponse] = await Promise.all([
                // esimApi.getMonthlyLimit(),
                esimApi.getEsims()
            ]);

            const limit = esimsResponse?.data?.monthlyLimit || null;
            const plans = (esimsResponse?.data.items || []).map((item, index) => {
                const mappedState = this.getPlanStatusAndAction(item);
                return {
                    id: item.esimId || index + 1,
                    planId: item.planId || null,
                    destinationCode: item.destinationCode || null,
                    country: item.planTitle || 'Unknown',
                    flag: item.flagUrl || '🌍',
                    status: mappedState.status,
                    statusLabel: mappedState.statusLabel,
                    remainingMb: item.dataMbRemaining ?? 0,
                    dataMbTotal: item.dataMbTotal ?? 0,
                    dataMbUsed: item.dataMbUsed ?? 0,
                    depleted: Boolean(item.depleted),
                    canTopUp: Boolean(item.canTopUp),
                    daysLeft: item.daysLeft || '',
                    price: item.price ? `${item.price} ${item.currency || ''}`.trim() : '—',
                    primaryAction: mappedState.primaryAction
                };
            });

            this.setState({ limit, plans, isLoading: false });
        } catch (error) {
            this.setState({ isLoading: false });
        }
    }

    setFilter = (activeFilter) => {
        this.setState({ activeFilter });
    }

    getVisiblePlans = () => {
        const { activeFilter, plans } = this.state;

        if (activeFilter === 'all') {
            return plans;
        }

        return plans.filter((item) => item.status === activeFilter);
    }

    openPlanDetails = (plan) => {
        this.props.history.push({
            pathname: `/dashboard/services/e-sim/my-esims/${plan.id}`,
            state: { plan }
        });
    }

    handlePrimaryAction = (plan) => {
        if (plan.primaryAction === 'Setup') {
            this.props.history.push({
                pathname: `/dashboard/services/e-sim/setup/${encodeURIComponent(plan.planId)}/${plan.id}`,
                state: {
                    selectedCountry: { name: plan.country, flag: plan.flag },
                    selectedPlan: { id: plan.id, volume: `${plan.dataMbTotal} GB` }
                }
            });
            return;
        }

        if (plan.primaryAction === 'Reinstall') {
            this.props.history.push(`/dashboard/services/e-sim/details/${encodeURIComponent(plan.planId)}`);
            return;
        }

        if (plan.primaryAction === 'Top Up') {
            this.props.history.push(`/dashboard/services/e-sim/details/${encodeURIComponent(plan.destinationCode)}/${encodeURIComponent(plan.id)}`);
            // console.log(plan)
            return;
        }

        this.openPlanDetails(plan);
    }

    formatCentsAmount = (amountCents) => {
        const amount = Number(amountCents || 0) / 100;
        const fixed = amount.toFixed(2);

        return fixed.endsWith('.00') ? fixed.slice(0, -3) : fixed;
    }

    render() {
        const { limit, filters, activeFilter } = this.state;
        const visiblePlans = this.getVisiblePlans();

        return (
            <>
                <div className="dashboard-header-route">
                    <div className="dashboard-header-route-left">
                        <button onClick={() => this.props.history.goBack()}>
                            <svg width="22" height="22" viewBox="0 0 22 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M11.7344 21.2188L12.6719 20.3281C12.9062 20.0938 12.9062 19.7188 12.6719 19.5312L5.40625 12.2188H21.4375C21.7188 12.2188 22 11.9844 22 11.6562V10.3438C22 10.0625 21.7188 9.78125 21.4375 9.78125H5.40625L12.6719 2.51562C12.9062 2.32812 12.9062 1.95312 12.6719 1.71875L11.7344 0.828125C11.5469 0.59375 11.1719 0.59375 10.9375 0.828125L1.14062 10.625C0.90625 10.8594 0.90625 11.1875 1.14062 11.4219L10.9375 21.2188C11.1719 21.4531 11.5469 21.4531 11.7344 21.2188Z" fill="#2E3131" />
                            </svg>
                        </button>
                        <h2>{this.props.t('eSIMlərim')}</h2>
                    </div>
                </div>

                <div className="dashboard-account-body">
                    <div className="m-3" style={{ marginTop: '1px' }}>
                        <div className="dashboard-esim-my-layout">
                            <div className="dashboard-esim-my-main">
                                <div className="dashboard-esim-my-top-bar">
                                    <div className="dashboard-esim-my-limit-card">
                                        <span>{this.props.t('Mövcud limit')}</span>
                                        <strong>{this.formatCentsAmount(limit?.usedAmountCents)} {limit?.currency} / {this.formatCentsAmount(limit?.limitAmountCents)} {limit?.currency}</strong>
                                    </div>
                                    {/* {isLoading ? <span className="dashboard-esim-my-loading">Yüklənir...</span> : null} */}

                                    {/* <button type="button" className="dashboard-esim-my-order-btn" onClick={() => this.props.history.push('/dashboard/services/e-sim')}>
                                        eSIM sifariş et
                                    </button> */}
                                </div>

                                <h3>{this.props.t('eSIMlərim')}</h3>

                                <div className="dashboard-esim-my-filters">
                                    {filters.map((filter) => (
                                        <button
                                            key={filter.key}
                                            type="button"
                                            className={`dashboard-esim-my-filter ${activeFilter === filter.key ? 'dashboard-esim-my-filter__active' : ''}`}
                                            onClick={() => this.setFilter(filter.key)}
                                        >
                                            {filter.label}
                                        </button>
                                    ))}
                                </div>

                                <div className="dashboard-esim-my-cards">
                                    {visiblePlans.map((plan) => {
                                        const usedPercent = plan.dataMbTotal > 0
                                            ? Math.max(0, Math.min(100, (plan.remainingMb / plan.dataMbTotal) * 100))
                                            : 100;
                                        return (
                                            <div className="dashboard-esim-my-card" key={plan.id}>
                                                <div className="dashboard-esim-my-card-head">
                                                    <div className="dashboard-esim-my-card-country">
                                                        {plan.flag && String(plan.flag).indexOf('http') === 0
                                                            ? <img src={plan.flag} alt={plan.country} width="36" height="28" />
                                                            : plan.flag}
                                                        <h4>{plan.country}</h4>
                                                    </div>
                                                    <span className={`dashboard-esim-my-status dashboard-esim-my-status__${plan.status}`}>● {plan.statusLabel}</span>
                                                </div>

                                                <div className="dashboard-esim-my-usage-row">
                                                    <span>{plan.remainingMb} {this.props.t('MB remaining')}</span>
                                                    <span>{plan.dataMbTotal} {this.props.t('MB total')}</span>
                                                </div>

                                                <div className="dashboard-esim-my-progress">
                                                    <div style={{ width: `${usedPercent}%` }} />
                                                </div>

                                                <div className="dashboard-esim-my-meta-row">
                                                    <span><svg xmlns="http://www.w3.org/2000/svg" width="11" height="11" viewBox="0 0 11 11" fill="none">
                                                        <g clip-path="url(#clip0_184_11078)">
                                                            <path d="M5.50002 10.0832C8.03133 10.0832 10.0834 8.03114 10.0834 5.49984C10.0834 2.96853 8.03133 0.916504 5.50002 0.916504C2.96872 0.916504 0.916687 2.96853 0.916687 5.49984C0.916687 8.03114 2.96872 10.0832 5.50002 10.0832Z" stroke="#9CA3AF" stroke-width="0.916667" stroke-linecap="round" stroke-linejoin="round" />
                                                            <path d="M5.5 2.75V5.5L7.33333 6.41667" stroke="#9CA3AF" stroke-width="0.916667" stroke-linecap="round" stroke-linejoin="round" />
                                                        </g></svg> {plan.daysLeft ? `${plan.daysLeft} ${this.props.t('day')}` : '-'}</span>
                                                    <span>{plan.price}</span>
                                                </div>
                                                <hr />

                                                <div className="dashboard-esim-my-actions">
                                                    {plan.primaryAction ? <button type="button" onClick={() => this.handlePrimaryAction(plan)}>{this.props.t(plan.primaryAction)}</button> : null}
                                                    <button type="button" className="dashboard-esim-my-view-btn" onClick={() => this.openPlanDetails(plan)}>{this.props.t('View')}</button>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>

                            {/* <aside className="dashboard-esim-my-side">
                                <h4>{helpInfo.title}</h4>
                                <div className="dashboard-esim-my-side-illustration" aria-hidden="true" />
                                <p>{helpInfo.description}</p>
                            </aside> */}
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default translate('translation')(ESIMMyPlans);